<template>
  <el-dialog
    :title="title"
    ref="dialogversion"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="70%"
    top="5%"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="top">
      <div class="left">
        <el-button
          type="primary"
          @click="onCreateClick()"
          v-permission="'dci_version_manage-*'"
        >
          <i class="fas fa-plus"></i> 新增版本
        </el-button>
      </div>
      <div class="right">
        <el-input
          clearable
          v-model.trim="former['VersionName:like']"
          placeholder="请输入版本号"
          @keydown.enter.native="onSubmitQuery"
          style="width: 200px"
        ></el-input
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table
      :data="itemList"
      v-loading="loading"
      style="margin-bottom: 10px"
      tooltip-effect="light"
    >
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column prop="VersionName" label="版本号">
        <template slot-scope="scope">
          {{ scope.row.VersionName }}
          <el-tooltip
            content="Top center"
            placement="top"
            effect="light"
            v-if="scope.row.DownloadUrl !== ''"
          >
            <div slot="content">下载地址:<br />{{ scope.row.DownloadUrl }}</div>
            <i
              class="fas fa-clone"
              style="color: #67c23a; cursor: pointer"
              v-clipboard="scope.row.DownloadUrl"
              v-clipboard:success="onSuccess"
              v-clipboard:error="onError"
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="Md5" label="MD5" width="240" />
      <el-table-column label="发布日期" width="90">
        <template slot-scope="scope">
          <div v-if="scope.row.PublishAt">
            {{ $sys.dateFormat(scope.row.PublishAt, "Y-m-d") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="Desc" label="说明">
        <template slot-scope="scope">
          <div>{{ scope.row.Desc }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="Desc"
        label="关联文件系统版本"
        width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-if="scope.row.DciPvProductVersions">
            <div v-for="pro in scope.row.DciPvProductVersions" :key="pro.ID">
              <div>{{ pro.PvName }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="180" label="操作">
        <template slot-scope="scope">
          <el-upload
            :ref="'upload' + scope.$index"
            style="float: left; padding-right: 10px"
            action=""
            :headers="uploadHeader"
            :http-request="
              (file) => {
                return imggreySuccess(file, scope.row, scope.$index);
              }
            "
            :multiple="false"
            :limit="1"
            :show-file-list="false"
          >
            <el-button
              type="success"
              title="上传"
              v-permission="'dci_version_manage-*'"
            >
              <i class="fas fa-upload"></i>
            </el-button>
          </el-upload>
          <el-button
            type="success"
            @click.stop="onDownload(scope.row)"
            title="下载"
            :disabled="scope.row.DownloadUrl === ''"
          >
            <i class="fas fa-download"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onEditItemClick(scope.row)"
            title="编辑"
            v-permission="'dci_version_manage-*'"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
            v-permission="'dci_version_manage-*'"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 关 闭
      </el-button>
    </div>

    <el-dialog
      :title="(this.versionItem.ID ? '编辑' : '新增') + '相关版本'"
      :visible.sync="versionVisible"
      append-to-body
      :close-on-click-modal="false"
      @close="onCloseVersionItem"
      width="30%"
    >
      <el-form
        ref="versionItemForm"
        label-width="120px"
        :model="versionItem"
        :rules="rules"
      >
        <el-form-item label="版本号" prop="VersionName">
          <el-input
            v-model.trim="versionItem.VersionName"
            placeholder="请输入版本号"
          ></el-input>
        </el-form-item>
        <el-form-item label="发布日期" prop="PublishAt">
          <el-date-picker
            v-model="versionItem.PublishAt"
            style="width: 100%"
            type="date"
            placeholder="请选择发布日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="说明" prop="Desc">
          <el-input
            v-model.trim="versionItem.Desc"
            :autosize="{ minRows: 3 }"
            type="textarea"
            placeholder="请输入说明"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseVersionItem">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button
          type="primary"
          @click="onConfirmVersionItem"
          :disabled="submitting"
        >
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      softwareItem: _.clone(this.value), //应用程序
      itemList: [], //相关版本号
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        DciPvSoftwareID: "",
        "VersionName:like": "",
      },
      submitting: false,
      versionVisible: false,
      versionItem: {
        //版本
        ID: 0,
        VersionName: "", //版本号
        DciPvSoftwareID: 0, //应用程序id
        PublishAt: new Date(), //发布日期
        Desc: "", //描述
      },
      rules: {
        VersionName: [
          { required: true, message: "版本号不能为空", trigger: "blur" },
        ],
      },
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem("jwtToken")}`,
        Accept: "application/json",
      },
      title: "",
    };
  },
  methods: {
    onOpen() {
      this.softwareItem = _.cloneDeep(this.value);

      this.title =
        "相关版本(" +
        this.softwareItem.DciPvSoftwareClassify.ClassName +
        "-" +
        this.softwareItem.SoftwareName +
        ")";

      this.former.DciPvSoftwareID = this.softwareItem.ID;
      this.getItemList();
    },
    onClose() {
      this.$emit("form:saved", true);
      this.$emit("update:visible", false);
      this.itemList = [];
    },
    //获取应用程序相关版本
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/pv/softwareversion", {
          params: {
            where: this.former,
            ...this.pager,
            with: ["DciPvProductVersions"],
            order: ["-publish_at"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //点击新增版本按钮
    onCreateClick() {
      this.versionItem = this.getEmptyVersionItem();
      this.versionItem.DciPvSoftwareID = this.softwareItem.ID;
      this.versionVisible = true;
    },
    onCloseVersionItem() {
      this.versionVisible = false;
      this.$refs.versionItemForm.resetFields();
    },
    //点击编辑版本
    onEditItemClick(row) {
      this.versionItem = row;
      this.versionVisible = true;
    },
    //确认新增/保存版本
    onConfirmVersionItem() {
      this.$refs.versionItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.versionItem);
        const itemData = { ...this.versionItem };
        // 保存的操作
        this.$axios
          .request({
            url: this.versionItem.ID
              ? `dci/pv/softwareversion/${itemData.ID}`
              : "dci/pv/softwareversion",
            method: itemData.ID ? "put" : "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success(itemData.ID ? "编辑成功" : "新增成功");
            this.versionVisible = false;
            this.getItemList();
            this.getTagList();
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
    getEmptyVersionItem() {
      return {
        ID: 0,
        VersionName: "",
        DciPvSoftwareID: this.softwareItem.ID,
        PublishAt: new Date(),
        Desc: "",
      };
    },

    //上传附件
    async imggreySuccess(params, row, rowsIndex) {
      // const isLt2M = params.file.size / 1024 / 1024 < 2
      // if (!isLt2M) {
      //   this.$message.error('请上传2M以下的文件')
      //   return false
      // }
      this.loading = true;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", params.file);
      formData.append("id", row.ID);
      this.$axios
        .post(`dci/softwareversion/attachment`, formData)
        .then(() => {
          this.$message.success("上传成功");
          this.getItemList();
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.$refs["upload" + rowsIndex].clearFiles();
          this.loading = false;
        });
    },

    //下载
    async onDownload(row) {
      const { data } = await this.$axios({
        url: row.DownloadUrl,
        responseType: "blob",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      });
      const blob = new Blob([data], {
        type: "application/*;chartset=UTF-8",
      });
      const a = document.createElement("a");
      const url = window.URL.createObjectURL(blob);
      let filename = row.VersionName;
      if (row.DownloadUrl.indexOf("/") !== -1) {
        const arr = row.DownloadUrl.split("/");
        filename = arr[arr.length - 1];
      }

      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    },

    //删除相关版本
    onDeleteItem(row) {
      this.$confirm("确定要删除此版本吗？", "提示")
        .then(() => this.$axios.delete(`dci/pv/softwareversion/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },

    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },

    onSuccess() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.success("复制失败");
    },
  },
};
</script>
<style lang="scss" scoped>
.top {
  text-align: right;
  background-color: #f5f7fa;
  height: 30px;
  padding: 15px 20px 10px 20px;
  margin: -20px -20px 10px -20px;
}
.left {
  float: left;
  text-align: left;
  width: 80px;
  background-color: #f5f7fa;
}
.right {
  float: right;
  text-align: right;
  width: 80%;
}
</style>

